const initialState = {
  packageList: [],
};

export const packagesReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "packages")
    return action.execute(state);
  return state;
};
